<template>
    <div>
        <el-card class="box-card" v-loading="loading">
          <el-button type="info" @click="backCustomerManagement">返回</el-button>

          <el-table :data="dataList" border stripe class="mt15">
              <el-table-column prop="Ip" label="IP"></el-table-column>
              <el-table-column prop="Country" label="国家"></el-table-column>
              <el-table-column prop="Region" label="区域"></el-table-column>
              <el-table-column prop="Province" label="省"></el-table-column>
              <el-table-column prop="City" label="市"></el-table-column>
              <el-table-column prop="Isp" label="ISP"></el-table-column>
              <el-table-column prop="Createtime" label="时间"></el-table-column>
          </el-table>

            <!-- 分页 -->
            <div class="pages">
              <el-pagination
                @current-change="handleCurrentPageChange"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="dataListnum"
                :current-page.sync="selectedPageNo">
              </el-pagination>
            </div>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      loading: false,
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetcustomeripnum()
      this.apigetcustomeriplist()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetcustomeriplist()
    },
    apigetcustomeriplist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomeriplist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = []
            response.data.List.filter((item1, i1) => {
              that.dataList.push({ Ip: item1.Ip, Country: item1.Country, Region: item1.Region, Province: item1.Province, City: item1.City, Isp: item1.Isp, Createtime: item1.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetcustomeripnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomeripnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
